import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Organisation } from 'requests/nswag/atlas/AtlasClient';
import { useLocationContext } from './Location/LocationProvider';

type OrganisationDotMenuProps = {
  organisation: Organisation;
};

function OrganisationDotMenu({ organisation }: OrganisationDotMenuProps) {
  const [menuAnchorEl, setMenuAnchorEl] = useState<(EventTarget & Element) | null>(null);

  const { setDeleteLocation, setRenameLocation, setCreateLocation } = useLocationContext();

  function onMenuClick(event: React.MouseEvent<HTMLElement>) {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  }

  function onMenuClose() {
    setMenuAnchorEl(null);
  }

  const open = Boolean(menuAnchorEl);
  return (
    <>
      <IconButton style={{ padding: 0 }} onClick={onMenuClick} size="large">
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={menuAnchorEl}
        keepMounted
        open={open}
        onClose={onMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            setCreateLocation(organisation);
            onMenuClose();
          }}
        >
          <Typography>Create department</Typography>
        </MenuItem>
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            setRenameLocation(organisation);
            onMenuClose();
          }}
        >
          <Typography>Rename organisation</Typography>
        </MenuItem>
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            setDeleteLocation(organisation);
            onMenuClose();
          }}
        >
          <Typography>Delete organisation</Typography>
        </MenuItem>
      </Menu>
    </>
  );
}

export default OrganisationDotMenu;
